module.exports = __webpack_public_path__ + "img/prn_icon.0c57706.png";